import { reportEvent } from '../api/tracking'

/**
 * 全局错误上报
 * - Vue 组件运行时错误
 * - window.onerror 同步/异步 JS 错误
 * - unhandledrejection 未处理 Promise
 * 所有错误走埋点管道（队列 + sendBeacon 兜底），不额外新增接口
 */

var MAX_MSG_LEN = 500
var reportedCache = {}   // 简单去重：相同错误 60s 内只上报一次
var DEDUPE_TTL = 60000

function safeStr(v) {
  if (!v) return ''
  try { return String(v).slice(0, MAX_MSG_LEN) } catch (e) { return '' }
}

function shouldReport(key) {
  var now = Date.now()
  var t = reportedCache[key] || 0
  if (now - t < DEDUPE_TTL) return false
  reportedCache[key] = now
  return true
}

function currentUserId(store) {
  var ui = store && store.state && store.state.userInfo
  return ui && ui.userId ? ui.userId : null
}

function report(store, errorType, err, extra) {
  var userId = currentUserId(store)
  if (!userId) return                    // 未登录时不上报，避免脏数据
  var message = safeStr(err && (err.message || err))
  var stack = safeStr(err && err.stack)
  var key = errorType + '|' + message
  if (!shouldReport(key)) return
  var uid = /^\d+$/.test(String(userId)) ? Number(userId) : userId
  reportEvent({
    eventName: 'client_error',
    userId: uid,
    source: '',
    pageName: (window.location && window.location.hash) || '',
    eventData: {
      errorType: errorType,
      message: message,
      stack: stack,
      ua: navigator.userAgent,
      href: window.location.href,
      extra: extra || null
    }
  }).catch(function() {})
}

export function installErrorHandler(Vue, store) {
  // 1) Vue 组件错误
  Vue.config.errorHandler = function(err, vm, info) {
    report(store, 'vue', err, info)
    if (typeof console !== 'undefined') console.error('[Vue error]', err, info)
  }

  // 2) 全局 JS 错误
  window.addEventListener('error', function(e) {
    var target = e.target
    // 资源加载错误（img/script）也捕获
    if (target && (target.src || target.href) && target !== window) {
      report(store, 'resource', new Error('resource fail: ' + (target.src || target.href)))
      return
    }
    report(store, 'window', e.error || e.message)
  }, true)

  // 3) 未捕获的 Promise rejection
  window.addEventListener('unhandledrejection', function(e) {
    report(store, 'promise', e.reason)
  })
}
